import { render, staticRenderFns } from "./MatchedsTable.vue?vue&type=template&id=b885c154&scoped=true&"
import script from "./MatchedsTable.vue?vue&type=script&lang=ts&"
export * from "./MatchedsTable.vue?vue&type=script&lang=ts&"
import style0 from "./MatchedsTable.vue?vue&type=style&index=0&id=b885c154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b885c154",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VChip,VDataTable})
